import { styled, lighten } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const EmployeeNameContainer = styled(Grid)({
  "&:hover": {
    cursor: "pointer",
  },
});

export const MainTableContainer = styled(Grid)(({ theme }) => ({
  "& .isWeekend": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },

  "& .isPublicHoliday": {
    backgroundColor: "pink",
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },
}));

export const ExtraHoursContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  width: "100%",

  "& > .MuiButton-root": {
    padding: "0px",
  },
});

export const StatusIndicator = styled(Grid, {
  shouldForwardProp: (props) => props !== "isRejected" && props !== "isApproved" && props !== "isCancelled",
})<{ isRejected: boolean; isApproved: boolean; isCancelled: boolean }>(
  ({ isApproved, isRejected, isCancelled, theme: { palette } }) => ({
    color: isCancelled
      ? palette.grey[400]
      : isRejected
      ? palette.warning.light
      : isApproved
      ? palette.success.main
      : palette.primary.light,
    textDecoration: isRejected || isCancelled ? "line-through" : "",
    width: "78px",
    padding: "1px",
    textAlign: "center",
    fontWeight: 550,
  })
);

export const ClientIconContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",
});
